import React from 'react';
export const BonusesSection = () => {
  const bonuses = [{
    num: '01',
    icon: '🚨',
    name: 'Kit de Emergencia Emocional',
    desc: '8 fichas de emergencia para cualquier crisis. Pánico, ira, derrumbe, ansiedad social, crisis nocturna, rechazo, crisis académica y digital. Listo para usar en 60 segundos.'
  }, {
    num: '02',
    icon: '👨‍👩‍👧',
    name: 'Guía Decodificador para Padres',
    desc: 'Manual completo para padres y madres. Qué aprende en cada módulo, cómo hablar de emociones, scripts para conversaciones difíciles y señales de alerta vs progreso.'
  }, {
    num: '03',
    icon: '⭐',
    name: 'Plan de 30 Días de Autoestima',
    desc: '30 retos de 5 minutos, 30 reflexiones guiadas y 30 afirmaciones construidas desde evidencia real. Un mes completo para instalar autoestima sólida de adentro hacia afuera.'
  }];
  return <section className="bg-biosync-bgAlt py-10 px-5 sm:px-10" data-id="element-19">
      <div className="max-w-[1100px] mx-auto" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl sm:text-4xl font-bold text-biosync mb-2" data-id="element-22">
            "🎁 MÁS LOS 3 BONOS ESTRATÉGICOS"
          </h2>
          <p className="text-biosync-textSec text-lg" data-id="element-23">
            "Incluidos siempre — sin costo extra"
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-24">
          {bonuses.map((bono, i) => <div key={i} className="bg-white border border-biosync/30 rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-25">
              <div className="flex items-center justify-between mb-6" data-id="element-26">
                <span className="bg-biosync text-white font-bold text-sm py-1 px-3 rounded-full" data-id="element-27">
                  {bono.num}
                </span>
                <span className="text-4xl" data-id="element-28">{bono.icon}</span>
              </div>
              <h3 className="text-xl font-bold text-biosync-text mb-4" data-id="element-29">
                {bono.name}
              </h3>
              <p className="text-biosync-textSec text-sm mb-6 flex-grow leading-relaxed" data-id="element-30">
                {bono.desc}
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-31">
                <span className="text-red-500 line-through text-sm font-medium" data-id="element-32">
                  $15.000 ARS
                </span>
                <span className="text-biosync font-bold text-sm uppercase" data-id="element-33">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};